/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SeccionSectionRouteImport } from './routes/seccion.$section'
import { Route as SeccionSectionSubsectionRouteImport } from './routes/seccion.$section_.$subsection'
import { Route as SeccionSectionSubsectionArticleRouteImport } from './routes/seccion.$section_.$subsection_.$article'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SeccionSectionRoute = SeccionSectionRouteImport.update({
  id: '/seccion/$section',
  path: '/seccion/$section',
  getParentRoute: () => rootRouteImport,
} as any)
const SeccionSectionSubsectionRoute =
  SeccionSectionSubsectionRouteImport.update({
    id: '/seccion/$section_/$subsection',
    path: '/seccion/$section/$subsection',
    getParentRoute: () => rootRouteImport,
  } as any)
const SeccionSectionSubsectionArticleRoute =
  SeccionSectionSubsectionArticleRouteImport.update({
    id: '/seccion/$section_/$subsection_/$article',
    path: '/seccion/$section/$subsection/$article',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/seccion/$section': typeof SeccionSectionRoute
  '/seccion/$section/$subsection': typeof SeccionSectionSubsectionRoute
  '/seccion/$section/$subsection/$article': typeof SeccionSectionSubsectionArticleRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/seccion/$section': typeof SeccionSectionRoute
  '/seccion/$section/$subsection': typeof SeccionSectionSubsectionRoute
  '/seccion/$section/$subsection/$article': typeof SeccionSectionSubsectionArticleRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/seccion/$section': typeof SeccionSectionRoute
  '/seccion/$section_/$subsection': typeof SeccionSectionSubsectionRoute
  '/seccion/$section_/$subsection_/$article': typeof SeccionSectionSubsectionArticleRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/seccion/$section'
    | '/seccion/$section/$subsection'
    | '/seccion/$section/$subsection/$article'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/seccion/$section'
    | '/seccion/$section/$subsection'
    | '/seccion/$section/$subsection/$article'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/seccion/$section'
    | '/seccion/$section_/$subsection'
    | '/seccion/$section_/$subsection_/$article'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  LoginRoute: typeof LoginRoute
  SeccionSectionRoute: typeof SeccionSectionRoute
  SeccionSectionSubsectionRoute: typeof SeccionSectionSubsectionRoute
  SeccionSectionSubsectionArticleRoute: typeof SeccionSectionSubsectionArticleRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seccion/$section': {
      id: '/seccion/$section'
      path: '/seccion/$section'
      fullPath: '/seccion/$section'
      preLoaderRoute: typeof SeccionSectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seccion/$section_/$subsection': {
      id: '/seccion/$section_/$subsection'
      path: '/seccion/$section/$subsection'
      fullPath: '/seccion/$section/$subsection'
      preLoaderRoute: typeof SeccionSectionSubsectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seccion/$section_/$subsection_/$article': {
      id: '/seccion/$section_/$subsection_/$article'
      path: '/seccion/$section/$subsection/$article'
      fullPath: '/seccion/$section/$subsection/$article'
      preLoaderRoute: typeof SeccionSectionSubsectionArticleRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  LoginRoute: LoginRoute,
  SeccionSectionRoute: SeccionSectionRoute,
  SeccionSectionSubsectionRoute: SeccionSectionSubsectionRoute,
  SeccionSectionSubsectionArticleRoute: SeccionSectionSubsectionArticleRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
